// extracted by mini-css-extract-plugin
module.exports = {"faq":"faq-module--faq--1H7mI","question":"faq-module--question--1tOw6","answer":"faq-module--answer--3yppE"};